/* Copyright 2024 Marimo. All rights reserved. */
import React, { type PropsWithChildren } from "react";

const style = {
  display: "contents",
};

/**
 * Adds the 'marimo' className which serves as a namespace to its children,
 * so that the styles are scoped to the DOM subtree.
 * 
 * For library builds, also adds 'marimo-editor-root' to match the postcss-prefixwrap
 * scoping applied during the library build process.
 */
export const StyleNamespace = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>(({ children }, ref) => {
  // Add both classes for maximum compatibility
  const className = import.meta.env.VITE_MARIMO_VERSION === 'library' 
    ? 'marimo marimo-editor-root' 
    : 'marimo';
    
  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  );
});

StyleNamespace.displayName = "StyleNamespace";
